<template>
    <header :class="{ 'pl-72': isSidebar, 'pl-[72px]': !isSidebar }" class="transition-all">
        <div class="pt-5 grid grid-cols-2">
            <div class=" px-10 flex justify-between items-center">
                <!-- <div class="">
                    <img src="@/assets/logo.png" alt="logo"/>
                </div>
                <div class="flex">
                    <button class="btn-primary ml-3">
                        <span class="pr-2">
                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" class="w-5 h-5">
                                <path d="M6.25 6.375a4.125 4.125 0 118.25 0 4.125 4.125 0 01-8.25 0zM3.25 19.125a7.125 7.125 0 0114.25 0v.003l-.001.119a.75.75 0 01-.363.63 13.067 13.067 0 01-6.761 1.873c-2.472 0-4.786-.684-6.76-1.873a.75.75 0 01-.364-.63l-.001-.122zM19.75 7.5a.75.75 0 00-1.5 0v2.25H16a.75.75 0 000 1.5h2.25v2.25a.75.75 0 001.5 0v-2.25H22a.75.75 0 000-1.5h-2.25V7.5z" />
                            </svg>
                        </span>
                        <span>
                            Add Employee
                        </span>
                    </button>
                    <router-link v-if="role && (role.name === 'Super Admin' || role.permissions.includes('add_employee'))" class="btn-primary ml-3" to="/add-employee" >
                        <span class="">
                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" class="w-5 h-5">
                                <path d="M6.25 6.375a4.125 4.125 0 118.25 0 4.125 4.125 0 01-8.25 0zM3.25 19.125a7.125 7.125 0 0114.25 0v.003l-.001.119a.75.75 0 01-.363.63 13.067 13.067 0 01-6.761 1.873c-2.472 0-4.786-.684-6.76-1.873a.75.75 0 01-.364-.63l-.001-.122zM19.75 7.5a.75.75 0 00-1.5 0v2.25H16a.75.75 0 000 1.5h2.25v2.25a.75.75 0 001.5 0v-2.25H22a.75.75 0 000-1.5h-2.25V7.5z" />
                            </svg>
                        </span>
                        <span class="pl-2">
                            Add Employee
                        </span>
                    </router-link>
                </div> -->
                <div>
                    <h4 class="text-2xl text-black font-medium">Hi, {{ companyName }}</h4>
                    <p class="text-xs text-[#6B6B6B] font-normal">Today is {{ formattedDate }}</p>
                </div>
            </div>
            <div class="px-7">
                <div class="flex space-x-5 justify-end items-center">

                    <div v-if="isDashboard" class="date_picker relative h-[42px] border border-[#D6D6D6] rounded-md ml-3 w-12"
                        @click="handleDatepickerClick">
                        <div class="absolute top-1.5 left-1.5">
                            <span class="text-[20px] block text-[#3B82F6] font-bold leading-none text-center">{{
                                displayDay }}</span>
                            <span class="text-[11px] block text-[#535353] leading-none text-center">{{ displayLabel
                                }}</span>
                        </div>
                        <Datepicker ref="datepickerRef" v-model="date" placeholder="Select a date"
                            @update:modelValue="onDateChange" />
                    </div>
                      <router-link v-if="role && (role.name === 'Super Admin' || role.permissions.includes('add_employee'))" to="/add-employee" >
                    <button
                        class="border border-[#3B82F6] bg-[#3B82F6] text-sm px-4 py-2 rounded-lg text-white font-normal flex items-center">
                        <img class="object-cover mr-2" src="../../assets/add-plus.svg" alt="" />
                        Add Employee
                    </button>
                    </router-link>
                    <!-- <div class="relative w-80">
                        <button class="absolute top-3 right-4 text-neutral-500">
                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" class="w-5 h-5">
                                <path fill-rule="evenodd" d="M10.5 3.75a6.75 6.75 0 100 13.5 6.75 6.75 0 000-13.5zM2.25 10.5a8.25 8.25 0 1114.59 5.28l4.69 4.69a.75.75 0 11-1.06 1.06l-4.69-4.69A8.25 8.25 0 012.25 10.5z" clip-rule="evenodd" />
                            </svg>
                        </button>

                        <input type="search" class="focus:border-blue-500 transition-all outline-0 w-full border h-[42px] pr-10 leading-6 text-neutral-600 text-sm pl-3 py-1.5 rounded-3xl placeholder:text-[#A2A4A8]" placeholder="Type to search..." alt=""/>
                    </div> -->
                    <div class="relative">
                        <button @click="toggleDropdown('notification')"
                            class="text-neutral-600 hover:text-blue-500 transition-all relative block"
                            :data-tooltip="'You have ' + totalNotificationCount + ' new Notifications'"
                            data-tooltip-pos="down" data-tooltip-length="medium" ref="notificationBtn">

                            <span v-if="totalNotificationCount > 0"
                                class="absolute -top-1 -right-1 w-4 h-4 rounded-full bg-orange-500 text-[10px] text-white leading-4 text-center">
                                {{ totalNotificationCount }}
                            </span>
                            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
                                stroke="currentColor" class="w-6 h-6">
                                <path stroke-linecap="round" stroke-linejoin="round"
                                    d="M14.857 17.082a23.848 23.848 0 005.454-1.31A8.967 8.967 0 0118 9.75v-.7V9A6 6 0 006 9v.75a8.967 8.967 0 01-2.312 6.022c1.733.64 3.56 1.085 5.455 1.31m5.714 0a24.255 24.255 0 01-5.714 0m5.714 0a3 3 0 11-5.714 0" />
                            </svg>
                        </button>
                        <div v-if="activeDropdown === 'notification'"
                            class="w-[430px] z-[99] absolute w-xl rounded-md shadow-2xl top-6 right-0 bg-white">
                            <div class="bg-neutral-100 shadow px-3 py-3">
                                <h3 class="text-lg font-medium">Notification</h3>
                            </div>

                            <!-- Notification List -->
                            <ul class="flex flex-col divide-y divide-neutral-200 overflow-y-auto max-h-72"
                                @scroll="handleScroll" v-if="notificationList.notifications.length">
                                <li v-for="(notification, index) in notificationList.notifications" :key="index"
                                    class="text-sm text-black font-normal py-2 px-4 cursor-pointer hover:bg-gray-100"
                                    @click="markAsRead(notification.module, notification.page_id, notification.id)">
                                    {{ notification.message }}
                                    <br />
                                    <span class="text-xs text-gray-400">
                                        {{ formatDate(notification.date) }} {{ formatTime(notification.time) }} - {{
                                        notification?.employee?.fname }} {{ notification?.employee?.lname }}
                                    </span>
                                </li>
                                <li v-if="busy" class="py-2 px-4 text-sm text-gray-500 text-center">Loading...</li>
                            </ul>
                            <div v-else class="text-sm text-black font-normal py-2 px-4">No notifications available.
                            </div>
                        </div>
                    </div>

                    <!-- <button class="text-neutral-600 hover:text-blue-500 transition-all">
                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-6 h-6">
                            <path stroke-linecap="round" stroke-linejoin="round" d="M7.5 8.25h9m-9 3H12m-9.75 1.51c0 1.6 1.123 2.994 2.707 3.227 1.129.166 2.27.293 3.423.379.35.026.67.21.865.501L12 21l2.755-4.133a1.14 1.14 0 01.865-.501 48.172 48.172 0 003.423-.379c1.584-.233 2.707-1.626 2.707-3.228V6.741c0-1.602-1.123-2.995-2.707-3.228A48.394 48.394 0 0012 3c-2.392 0-4.744.175-7.043.513C3.373 3.746 2.25 5.14 2.25 6.741v6.018z" />
                        </svg>
                    </button>

                    <button class="text-neutral-600 hover:text-blue-500 transition-all">
                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-6 h-6">
                            <path stroke-linecap="round" stroke-linejoin="round" d="M7.5 14.25v2.25m3-4.5v4.5m3-6.75v6.75m3-9v9M6 20.25h12A2.25 2.25 0 0020.25 18V6A2.25 2.25 0 0018 3.75H6A2.25 2.25 0 003.75 6v12A2.25 2.25 0 006 20.25z" />
                        </svg>
                    </button> -->
                    <router-link to="#" class="block shrink-0 w-10 h-10 rounded-full">
                        <img class="w-full h-full object-cover " src="../../assets/user-nk.jpg" alt="" />
                    </router-link>
                </div>
            </div>
        </div>
    </header>
    <section class="LayoutDefault">
        <div class="fixed top-0 left-0 transition-all sidebar z-10 bg-slate-900 h-screen flex flex-col"
            :class="{ 'w-72': isSidebar, 'w-[72px]': !isSidebar }">
            <nav class="LayoutDefault__nav py-4 px-4 flex flex-col grow">
                <div class="pb-10" :class="isSidebar ? 'w-auto' : 'w-[30px]'">
                    <img src="@/assets/logo.png" alt="logo" class="h-[52px] object-cover object-left-top" />
                </div>
                <button
                    class="flex items-center justify-center absolute -right-3 top-7 w-6 h-6 rounded-full bg-[#2A3E58]"
                    @click="this.isSidebar = !isSidebar">
                    <i
                        :class="['fas fa-chevron-left text-xs text-[#98A2B3] transition-all', isSidebar ? 'rotate-0' : 'rotate-180']"></i>
                </button>

                <ul class="overflow-hidden flex flex-col grow">
                    <li class="pt-1.5">
                        <router-link active-class="bg-[#2A3E58]"
                            :class="isSidebar ? 'w-auto px-5 py-4' : 'w-10 h-10 p-3'"
                            class="flex flex-nowrap text-white/60 flex-1 rounded items-center hover:text-white transition-all"
                            :to="{ name: 'AdminDashboard', params: { id: this.companyId } }"
                            @click="this.isSidebar = false">
                            <svg width="14" height="14" viewBox="0 0 14 14" fill="none"
                                xmlns="http://www.w3.org/2000/svg" class="w-4 h-4 shrink-0">
                                <path
                                    d="M1.03704 0H5.44436C6.01732 0 6.4814 0.572955 6.4814 1.03703V8.03707C6.4814 8.61003 6.01732 9.0741 5.44436 9.0741H1.03704C0.464078 9.0741 0 8.50115 0 8.03707V1.03703C0 0.464075 0.464078 0 1.03704 0Z"
                                    fill="#F2F4F7" />
                                <path
                                    d="M1.03704 10.1111H5.44436C6.01732 10.1111 6.4814 10.684 6.4814 11.1481V12.963C6.4814 13.536 6.01732 14 5.44436 14H1.03704C0.464078 14 0 13.4271 0 12.963V11.1481C0 10.5752 0.464078 10.1111 1.03704 10.1111Z"
                                    fill="#F2F4F7" />
                                <path
                                    d="M8.55559 4.9259H12.9629C13.5359 4.9259 14 5.49886 14 5.96293V12.963C14 13.5359 13.5359 14 12.9629 14H8.55559C7.98263 14 7.51855 13.4271 7.51855 12.963V5.96293C7.51855 5.38998 7.98263 4.9259 8.55559 4.9259Z"
                                    fill="#F2F4F7" />
                                <path
                                    d="M8.55559 0H12.9629C13.5359 0 14 0.572955 14 1.03703V2.85192C14 3.42487 13.5359 3.88895 12.9629 3.88895H8.55559C7.98263 3.88895 7.51855 3.31599 7.51855 2.85192V1.03703C7.51855 0.464075 7.98263 0 8.55559 0Z"
                                    fill="#F2F4F7" />
                            </svg>
                            <span class="pl-3">
                                Dashboard
                            </span>
                        </router-link>
                    </li>
                    <li class="pt-1.5">
                        <button
                            :class="[isSidebar ? 'w-full px-5 py-4' : 'w-10 h-10 p-3', ($route.path === '/add-employee' || $route.path === '/employee-list') ? 'bg-[#2A3E58]' : 'bg-transparent']"
                            class="flex flex-nowrap text-white/60 flex-1 rounded items-center hover:text-white transition-all"
                            @click="HandelFirstDropdown('employee')">
                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor"
                                class="w-5 h-5 shrink-0">
                                <path
                                    d="M7 8a3 3 0 100-6 3 3 0 000 6zM14.5 9a2.5 2.5 0 100-5 2.5 2.5 0 000 5zM1.615 16.428a1.224 1.224 0 01-.569-1.175 6.002 6.002 0 0111.908 0c.058.467-.172.92-.57 1.174A9.953 9.953 0 017 18a9.953 9.953 0 01-5.385-1.572zM14.5 16h-.106c.07-.297.088-.611.048-.933a7.47 7.47 0 00-1.588-3.755 4.502 4.502 0 015.874 2.636.818.818 0 01-.36.98A7.465 7.465 0 0114.5 16z" />
                            </svg>
                            <span class="pl-3">
                                Employee
                            </span>
                            <span class="ml-auto">
                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor"
                                    class="w-4 h-4">
                                    <path fill-rule="evenodd"
                                        d="M12.53 16.28a.75.75 0 01-1.06 0l-7.5-7.5a.75.75 0 011.06-1.06L12 14.69l6.97-6.97a.75.75 0 111.06 1.06l-7.5 7.5z"
                                        clip-rule="evenodd" />
                                </svg>
                            </span>
                        </button>
                        <transition enter-active-class="transition duration-100 ease-out"
                            enter-from-class="transform scale-95 opacity-0"
                            enter-to-class="transform scale-100 opacity-100"
                            leave-active-class="transition duration-75 ease-in"
                            leave-from-class="transform scale-100 opacity-100"
                            leave-to-class="transform scale-95 opacity-0">
                            <ul class="pl-10" v-if="this.firstSideBarDrop === 'employee'">
                                <li
                                    v-if="role && (role.name === 'Super Admin' || role.permissions.includes('add_employee'))">
                                    <router-link active-class="!text-white"
                                        class="flex text-sm flex-nowrap text-white/60 flex-1 p-1.5 items-center hover:text-white transition-all"
                                        to="/add-employee" @click="this.isSidebar = true">
                                        <span>
                                            Add Employee
                                        </span>
                                    </router-link>
                                </li>
                                <li
                                    v-if="role && (role.name === 'Super Admin' || role.permissions.includes('employee_list'))">
                                    <router-link active-class="!text-white"
                                        class="flex text-sm flex-nowrap text-white/60 flex-1 p-1.5 items-center hover:text-white transition-all"
                                        to="/employee-list" @click="this.isSidebar = true">
                                        <span>
                                            Employee List
                                        </span>
                                    </router-link>
                                </li>
                            </ul>
                        </transition>
                    </li>
                    <li class="pt-1.5">
                        <button
                            :class="[isSidebar ? 'w-full px-5 py-4' : 'w-10 h-10 p-3', ($route.path === '/country-list' || $route.path === '/state-list' || $route.path === '/department-list' || $route.path === '/designation-list' || $route.path === '/reporting-manager-list' || $route.path === '/education-list' || $route.path === '/holiday-list' || $route.path === '/branch') ? 'bg-[#2A3E58] mb-3' : 'bg-transparent']"
                            class="flex flex-nowrap text-white/60 flex-1 rounded items-center hover:text-white transition-all"
                            @click="HandelSecondDropdown('MasterSettings')">
                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor"
                                class="w-4 h-4 shrink-0">
                                <path fill-rule="evenodd"
                                    d="M14.5 10a4.5 4.5 0 004.284-5.882c-.105-.324-.51-.391-.752-.15L15.34 6.66a.454.454 0 01-.493.11 3.01 3.01 0 01-1.618-1.616.455.455 0 01.11-.494l2.694-2.692c.24-.241.174-.647-.15-.752a4.5 4.5 0 00-5.873 4.575c.055.873-.128 1.808-.8 2.368l-7.23 6.024a2.724 2.724 0 103.837 3.837l6.024-7.23c.56-.672 1.495-.855 2.368-.8.096.007.193.01.291.01zM5 16a1 1 0 11-2 0 1 1 0 012 0z"
                                    clip-rule="evenodd" />
                                <path
                                    d="M14.5 11.5c.173 0 .345-.007.514-.022l3.754 3.754a2.5 2.5 0 01-3.536 3.536l-4.41-4.41 2.172-2.607c.052-.063.147-.138.342-.196.202-.06.469-.087.777-.067.128.008.257.012.387.012zM6 4.586l2.33 2.33a.452.452 0 01-.08.09L6.8 8.214 4.586 6H3.309a.5.5 0 01-.447-.276l-1.7-3.402a.5.5 0 01.093-.577l.49-.49a.5.5 0 01.577-.094l3.402 1.7A.5.5 0 016 3.31v1.277z" />
                            </svg>

                            <span class="pl-3">
                                Masters Settings
                            </span>

                            <span class="ml-auto">
                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor"
                                    class="w-4 h-4">
                                    <path fill-rule="evenodd"
                                        d="M12.53 16.28a.75.75 0 01-1.06 0l-7.5-7.5a.75.75 0 011.06-1.06L12 14.69l6.97-6.97a.75.75 0 111.06 1.06l-7.5 7.5z"
                                        clip-rule="evenodd" />
                                </svg>
                            </span>
                        </button>
                        <transition enter-active-class="transition duration-100 ease-out"
                            enter-from-class="transform scale-95 opacity-0"
                            enter-to-class="transform scale-100 opacity-100"
                            leave-active-class="transition duration-75 ease-in"
                            leave-from-class="transform scale-100 opacity-100"
                            leave-to-class="transform scale-95 opacity-0">
                            <ul class="pl-10" v-if="this.secondSideBarDrop === 'MasterSettings'">
                                <li>
                                    <router-link active-class="!text-white"
                                        v-if="role && (role.name === 'Super Admin' || role.permissions.includes('country'))"
                                        class="flex text-sm flex-nowrap text-white/60 flex-1 p-1.5 items-center hover:text-white transition-all"
                                        to="/country-list" @click="this.isSidebar = true">
                                        <span>
                                            Country
                                        </span>
                                    </router-link>
                                    <router-link active-class="!text-white"
                                        v-if="role && (role.name === 'Super Admin' || role.permissions.includes('state'))"
                                        class="flex text-sm flex-nowrap text-white/60 flex-1 p-1.5 items-center hover:text-white transition-all"
                                        to="/state-list" @click="this.isSidebar = true">
                                        <span>
                                            State
                                        </span>
                                    </router-link>
                                    <router-link active-class="!text-white"
                                        v-if="role && (role.name === 'Super Admin' || role.permissions.includes('department'))"
                                        class="flex text-sm flex-nowrap text-white/60 flex-1 p-1.5 items-center hover:text-white transition-all"
                                        to="/department-list" @click="this.isSidebar = true">
                                        <span>
                                            Department
                                        </span>
                                    </router-link>
                                    <router-link active-class="!text-white"
                                        v-if="role && (role.name === 'Super Admin' || role.permissions.includes('designation'))"
                                        class="flex text-sm flex-nowrap text-white/60 flex-1 p-1.5 items-center hover:text-white transition-all"
                                        to="/designation-list" @click="this.isSidebar = true">
                                        <span>
                                            Designation
                                        </span>
                                    </router-link>
                                    <router-link active-class="!text-white"
                                        v-if="role && (role.name === 'Super Admin' || role.permissions.includes('reporting_manager'))"
                                        class="flex text-sm flex-nowrap text-white/60 flex-1 p-1.5 items-center hover:text-white transition-all"
                                        to="/reporting-manager-list" @click="this.isSidebar = true">
                                        <span>
                                            Reporting Manager
                                        </span>
                                    </router-link>
                                    <router-link active-class="!text-white"
                                        v-if="role && (role.name === 'Super Admin' || role.permissions.includes('education'))"
                                        class="flex text-sm flex-nowrap text-white/60 flex-1 p-1.5 items-center hover:text-white transition-all"
                                        to="/education-list" @click="this.isSidebar = true">
                                        <span>
                                            Education
                                        </span>
                                    </router-link>
                                    <router-link active-class="!text-white"
                                        v-if="role && (role.name === 'Super Admin' || role.permissions.includes('holiday_master'))"
                                        class="flex text-sm flex-nowrap text-white/60 flex-1 p-1.5 items-center hover:text-white transition-all"
                                        to="/holiday-list" @click="this.isSidebar = true">
                                        <span>
                                            Holiday Master
                                        </span>
                                    </router-link>
                                    <router-link active-class="!text-white"
                                        v-if="role && (role.name === 'Super Admin' || role.permissions.includes('branch_master'))"
                                        class="flex text-sm flex-nowrap text-white/60 flex-1 p-1.5 items-center hover:text-white transition-all"
                                        to="/branch" @click="this.isSidebar = true">
                                        <span>
                                            Branch Master
                                        </span>
                                    </router-link>
                                </li>
                            </ul>
                        </transition>
                    </li>
                    <li class="pt-1.5">
                        <button
                            :class="[isSidebar ? 'w-full px-5 py-4' : 'w-10 h-10 p-2.5', ($route.path === '/organization-setting' || $route.path === '/role-allocation-setting' || $route.path === '/attendance-report' || $route.path === '/leave-report' || $route.path === '/payroll-setting' || $route.path === '/education-list' || $route.path === '/calculate-net-pay' || $route.path === '/salary-slip-and-approval' || $route.path === '/announcement') ? 'bg-[#2A3E58] mb-3' : 'bg-transparent']"
                            class="flex flex-nowrap text-white/60 flex-1 rounded items-center hover:text-white transition-all"
                            @click="HandelFirstDropdown('Settings')">
                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor"
                                class="w-5 h-5 shrink-0">
                                <path fill-rule="evenodd"
                                    d="M11.828 2.25c-.916 0-1.699.663-1.85 1.567l-.091.549a.798.798 0 01-.517.608 7.45 7.45 0 00-.478.198.798.798 0 01-.796-.064l-.453-.324a1.875 1.875 0 00-2.416.2l-.243.243a1.875 1.875 0 00-.2 2.416l.324.453a.798.798 0 01.064.796 7.448 7.448 0 00-.198.478.798.798 0 01-.608.517l-.55.092a1.875 1.875 0 00-1.566 1.849v.344c0 .916.663 1.699 1.567 1.85l.549.091c.281.047.508.25.608.517.06.162.127.321.198.478a.798.798 0 01-.064.796l-.324.453a1.875 1.875 0 00.2 2.416l.243.243c.648.648 1.67.733 2.416.2l.453-.324a.798.798 0 01.796-.064c.157.071.316.137.478.198.267.1.47.327.517.608l.092.55c.15.903.932 1.566 1.849 1.566h.344c.916 0 1.699-.663 1.85-1.567l.091-.549a.798.798 0 01.517-.608 7.52 7.52 0 00.478-.198.798.798 0 01.796.064l.453.324a1.875 1.875 0 002.416-.2l.243-.243c.648-.648.733-1.67.2-2.416l-.324-.453a.798.798 0 01-.064-.796c.071-.157.137-.316.198-.478.1-.267.327-.47.608-.517l.55-.091a1.875 1.875 0 001.566-1.85v-.344c0-.916-.663-1.699-1.567-1.85l-.549-.091a.798.798 0 01-.608-.517 7.507 7.507 0 00-.198-.478.798.798 0 01.064-.796l.324-.453a1.875 1.875 0 00-.2-2.416l-.243-.243a1.875 1.875 0 00-2.416-.2l-.453.324a.798.798 0 01-.796.064 7.462 7.462 0 00-.478-.198.798.798 0 01-.517-.608l-.091-.55a1.875 1.875 0 00-1.85-1.566h-.344zM12 15.75a3.75 3.75 0 100-7.5 3.75 3.75 0 000 7.5z"
                                    clip-rule="evenodd" />
                            </svg>

                            <span class="pl-3">
                                Settings
                            </span>

                            <span class="ml-auto">
                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor"
                                    class="w-4 h-4">
                                    <path fill-rule="evenodd"
                                        d="M12.53 16.28a.75.75 0 01-1.06 0l-7.5-7.5a.75.75 0 011.06-1.06L12 14.69l6.97-6.97a.75.75 0 111.06 1.06l-7.5 7.5z"
                                        clip-rule="evenodd" />
                                </svg>
                            </span>
                        </button>
                        <transition enter-active-class="transition duration-100 ease-out"
                            enter-from-class="transform scale-95 opacity-0"
                            enter-to-class="transform scale-100 opacity-100"
                            leave-active-class="transition duration-75 ease-in"
                            leave-from-class="transform scale-100 opacity-100"
                            leave-to-class="transform scale-95 opacity-0">
                            <ul class="pl-10" v-if="this.firstSideBarDrop === 'Settings'">
                                <li>
                                    <!-- <router-link class="flex text-sm flex-nowrap text-white/60 flex-1 p-1.5 items-center hover:text-white transition-all" to="/general-setting" @click="this.isSidebar = true">
                                        <span>
                                            General Settings
                                        </span>
                                    </router-link> -->
                                </li>

                                <li>
                                    <router-link active-class="!text-white"
                                        v-if="role && (role.name === 'Super Admin' || role.permissions.includes('organization_settings'))"
                                        class="flex text-sm flex-nowrap text-white/60 flex-1 p-1.5 items-center hover:text-white transition-all"
                                        to="/organization-setting" @click="this.isSidebar = true">
                                        <span>
                                            Organization Settings
                                        </span>
                                    </router-link>
                                </li>

                                <li>
                                    <router-link active-class="!text-white"
                                        v-if="role && (role.name === 'Super Admin' || role.permissions.includes('role_allocation_settings'))"
                                        class="flex text-sm flex-nowrap text-white/60 flex-1 p-1.5 items-center hover:text-white transition-all"
                                        to="/role-allocation-setting" @click="this.isSidebar = true">
                                        <span>
                                            Role Allocation Settings
                                        </span>
                                    </router-link>
                                </li>

                                <li>
                                    <router-link v-if="role && (role.name === 'Super Admin'
                                        || role.permissions.includes('attendance_settings')
                                        || role.permissions.includes('attendance_adjustment')
                                        || role.permissions.includes('attendance_report')
                                        || role.permissions.includes('wfh_report')
                                        || role.permissions.includes('date_change_report')
                                    )" class="flex text-sm flex-nowrap text-white/60 flex-1 p-1.5 items-center hover:text-white transition-all"
                                        to="/attendance" @click="this.isSidebar = true">
                                        <span>
                                            Attendance
                                        </span>
                                    </router-link>
                                    <!-- <ul v-if="openIndex === 0" class="pl-3 py-1">
                                        <li>
                                            <router-link v-if="role && (role.name === 'Super Admin' || role.permissions.includes('attendance_settings'))"  class="flex text-sm flex-nowrap text-white/60 flex-1 p-1.5 items-center hover:text-white transition-all" to="/attendance-setting" @click="this.isSidebar = true">
                                                <span>
                                                    Attendance Settings
                                                </span>
                                            </router-link>
                                        </li>
                                        <li>
                                            <router-link v-if="role && (role.name === 'Super Admin' || role.permissions.includes('attendance_adjustment'))"  class="flex text-sm flex-nowrap text-white/60 flex-1 p-1.5 items-center hover:text-white transition-all" to="/attendance-adjustment" @click="this.isSidebar = true">
                                                <span>
                                                    Attendance Adjustment
                                                </span>
                                            </router-link>
                                        </li>
                                        <li>
                                            <router-link v-if="role && (role.name === 'Super Admin' || role.permissions.includes('attendance_report'))"  class="flex text-sm flex-nowrap text-white/60 flex-1 p-1.5 items-center hover:text-white transition-all" to="/attendance-report" @click="this.isSidebar = true">
                                                <span>
                                                    Attendance Report
                                                </span>
                                            </router-link>
                                        </li>
                                        <li>
                                            <router-link v-if="role && (role.name === 'Super Admin' || role.permissions.includes('wfh_report'))" class="flex text-sm flex-nowrap text-white/60 flex-1 p-1.5 items-center hover:text-white transition-all" to="/wfh-report" @click="this.isSidebar = true">
                                                <span>
                                                    WFH Report
                                                </span>
                                            </router-link>
                                        </li>
                                        <li>                                            
                                            <router-link v-if="role && (role.name === 'Super Admin' || role.permissions.includes('date_change_report'))"  class="flex text-sm flex-nowrap text-white/60 flex-1 p-1.5 items-center hover:text-white transition-all" to="/date-change-report" @click="this.isSidebar = true">
                                                <span>
                                                    Date Change Report
                                                </span>
                                            </router-link>
                                        </li>
                                    </ul> -->
                                </li>

                                <li>
                                    <router-link v-if="role && (role.name === 'Super Admin'
                                        || role.permissions.includes('leave_report')
                                        || role.permissions.includes('leave_status')
                                        || role.permissions.includes('leave_listing')
                                        || role.permissions.includes('leave_settings')
                                        || role.permissions.includes('leave_carry_forward')
                                        || role.permissions.includes('leave_carry_admin')
                                    )" class="flex text-sm flex-nowrap text-white/60 flex-1 p-1.5 items-center hover:text-white transition-all"
                                        to="/leave" @click="this.isSidebar = true">
                                        <span> Leave</span>
                                    </router-link>
                                    <!-- <ul v-if="openIndex === 1" class="pl-3 py-1">
                                        <li>
                                            <router-link v-if="role && (role.name === 'Super Admin' || role.permissions.includes('leave_report'))" class="flex text-sm flex-nowrap text-white/60 flex-1 p-1.5 items-center hover:text-white transition-all" to="/leave-report" @click="this.isSidebar = true">
                                                <span>
                                                    Leave Report
                                                </span>
                                            </router-link>
                                        </li>
                                        <li>
                                            <router-link v-if="role && (role.name === 'Super Admin' || role.permissions.includes('leave_status'))" class="flex text-sm flex-nowrap text-white/60 flex-1 p-1.5 items-center hover:text-white transition-all" to="/leave-status" @click="this.isSidebar = true">
                                                <span>
                                                    Leave Status
                                                </span>
                                            </router-link>
                                        </li>
                                        <li>
                                            <router-link v-if="role && (role.name === 'Super Admin' || role.permissions.includes('leave_listing'))" class="flex text-sm flex-nowrap text-white/60 flex-1 p-1.5 items-center hover:text-white transition-all" to="/leave-listing" @click="this.isSidebar = true">
                                                <span>
                                                    Leave Listing
                                                </span>
                                            </router-link>
                                        </li>
                                        <li>
                                            <router-link v-if="role && (role.name === 'Super Admin' || role.permissions.includes('leave_settings'))" class="flex text-sm flex-nowrap text-white/60 flex-1 p-1.5 items-center hover:text-white transition-all" to="/leave-setting" @click="this.isSidebar = true">
                                                <span>
                                                    Leave Settings
                                                </span>
                                            </router-link>
                                        </li>
                                        <li>
                                            <router-link v-if="role && (role.name === 'Super Admin' || role.permissions.includes('leave_carry_forward'))" class="flex text-sm flex-nowrap text-white/60 flex-1 p-1.5 items-center hover:text-white transition-all" to="/leave-carry-forward-&-payouts" @click="this.isSidebar = true">
                                                <span>
                                                    Leave Carry Forward & Payouts
                                                </span>
                                            </router-link>
                                        </li>
                                        <li>
                                            <router-link v-if="role && (role.name === 'Super Admin' || role.permissions.includes('leave_carry_admin'))" class="flex text-sm flex-nowrap text-white/60 flex-1 p-1.5 items-center hover:text-white transition-all" to="/leave-carry-admin-adjustment" @click="this.isSidebar = true">
                                                <span>
                                                    Leave Carry Admin Adjustment
                                                </span>
                                            </router-link>
                                        </li>
                                    </ul> -->
                                </li>


                                <li
                                    v-if="role && (role.name === 'Super Admin' || role.permissions.includes('payroll_settings'))">
                                    <router-link active-class="!text-white"
                                        class="flex text-sm flex-nowrap text-white/60 flex-1 p-1.5 items-center hover:text-white transition-all"
                                        to="/payroll-setting" @click="this.isSidebar = true">
                                        <span>
                                            Payroll Settings
                                        </span>
                                    </router-link>
                                </li>

                                <li
                                    v-if="role && (role.name === 'Super Admin' || role.permissions.includes('view_employee_payroll'))">
                                    <router-link active-class="!text-white"
                                        class="flex text-sm flex-nowrap text-white/60 flex-1 p-1.5 items-center hover:text-white transition-all"
                                        to="/calculate-net-pay" @click="this.isSidebar = true">
                                        <span>
                                            Calculate Net Pay
                                        </span>
                                    </router-link>
                                </li>


                                <li
                                    v-if="role && (role.name === 'Super Admin' || role.permissions.includes('view_employee_salary'))">
                                    <router-link active-class="!text-white"
                                        class="flex text-sm flex-nowrap text-white/60 flex-1 p-1.5 items-center hover:text-white transition-all"
                                        to="/salary-slip-approval" @click="this.isSidebar = true">
                                        <span>
                                            Salary Slip and Approval
                                        </span>
                                    </router-link>
                                </li>


                                <li>
                                    <router-link active-class="!text-white"
                                        v-if="role && (role.name === 'Super Admin' || role.permissions.includes('announcement'))"
                                        class="flex text-sm flex-nowrap text-white/60 flex-1 p-1.5 items-center hover:text-white transition-all"
                                        to="/announcement" @click="this.isSidebar = true">
                                        <span>
                                            Announcement
                                        </span>
                                    </router-link>
                                </li>


                                <!-- <li>
                                    <router-link class="flex text-sm flex-nowrap text-white/60 flex-1 p-1.5 items-center hover:text-white transition-all" to="/addemployeemaster" @click="this.isSidebar = true">
                                        <span>
                                            Employee Form Settings
                                        </span>
                                    </router-link>
                                </li> -->
                            </ul>
                        </transition>
                    </li>
                    <li class="pt-1.5 mt-auto">
                        <router-link
                            class="flex flex-nowrap text-white/60 flex-1 p-2.5 items-center hover:text-white transition-all"
                            to="/" @click="this.isSidebar = false">
                            <svg width="20" height="19" viewBox="0 0 20 19" fill="none"
                                xmlns="http://www.w3.org/2000/svg" class="w-5 h-5 shrink-0">
                                <path
                                    d="M12.5595 11.6627C12.0718 11.6627 11.6689 12.0655 11.6689 12.5532V15.0764H8.9125V3.77499H11.6477V6.2982C11.6477 6.78588 12.0506 7.18874 12.5383 7.18874C13.026 7.18874 13.4288 6.78588 13.4288 6.2982V2.86324C13.4288 2.37556 13.026 1.9727 12.5383 1.9727H8.9125V1.46381C8.9125 1.18817 8.78528 0.933728 8.57325 0.7641C8.36121 0.594472 8.08557 0.530862 7.83113 0.573269L0.855194 1.9939C0.431126 2.07871 0.134277 2.43917 0.134277 2.88444V16.0094C0.134277 16.4334 0.431126 16.8151 0.855194 16.8999L7.83113 18.2993C7.89474 18.3205 7.95835 18.3205 8.00075 18.3205C8.21279 18.3205 8.40362 18.2569 8.57325 18.1085C8.78528 17.9389 8.9125 17.6844 8.9125 17.4088V16.8999H12.5383C13.026 16.8999 13.4288 16.4971 13.4288 16.0094V12.5744C13.45 12.0655 13.0472 11.6627 12.5595 11.6627ZM6.19846 10.3905C5.66838 10.3905 5.24431 9.96639 5.24431 9.43631C5.24431 8.90622 5.66838 8.48215 6.19846 8.48215C6.72855 8.48215 7.15262 8.90622 7.15262 9.43631C7.15262 9.96639 6.72855 10.3905 6.19846 10.3905Z"
                                    fill="#F2F4F7" />
                                <path
                                    d="M19.0232 8.80021L16.394 6.17098C16.0335 5.81052 15.4822 5.81052 15.1218 6.17098C14.7613 6.53144 14.7613 7.08273 15.1218 7.44319L16.2031 8.52456H11.351C10.8633 8.52456 10.4604 8.92743 10.4604 9.41511C10.4604 9.90278 10.8633 10.3056 11.351 10.3056H16.2031L15.1218 11.387C14.7613 11.7475 14.7613 12.2988 15.1218 12.6592C15.2914 12.8289 15.5246 12.9137 15.7579 12.9137C15.9911 12.9137 16.2243 12.8289 16.394 12.6592L19.0232 10.0724C19.3625 9.71195 19.3625 9.16066 19.0232 8.80021Z"
                                    fill="#F2F4F7" />
                            </svg>
                            <span class="pl-3 whitespace-nowrap">
                                Log Out
                            </span>
                        </router-link>
                    </li>
                </ul>
            </nav>
        </div>

        <section :class="{ 'ml-72 w-[calc(100vw - 288px)]': isSidebar, 'ml-[72px] w-[calc(100vw - 72px)]': !isSidebar }"
            class="min-h-screen transition-all flex flex-col">
            <main class="w-full">
                <slot></slot>
            </main>
            <footer class="text-center text-sm mt-auto py-4 px-5">
                © 2025 Reddensoft Infotech. All rights reserved. Designed and developed by Reddensoft Infotech.
            </footer>
        </section>


    </section>
</template>
<script>
import { createLocal } from 'the-storages';
import axios from "axios";
import { BASE_URL } from "../../config";
const mirror = createLocal();
const storage = mirror._prx;
import moment from 'moment';
import Datepicker from 'vue3-datepicker';
//import { ref } from 'vue'
import { useDateStore } from '../../stores/useDateStore'

export default {
    name: 'AdminLayout',
    components: {
        Datepicker
    },

    data() {
        return {
            date: new Date(), // Default to current date
            role: null,
            storage: storage,
            isSidebar: false,
            firstSideBarDrop: '',
            secondSideBarDrop: '',
            companyId: '',
            // dashboardLink: ''
            currentPage: 1,
            openIndex: null,
            activeDropdown: null,
            notificationList: { notifications: [] },
            noMoreNotifications: false,
            totalNotificationCount: 0,
            busy: false,
            companyName: '',
            chevronDown: '<svg xmlns="http://www.w3.org/2000/svg" width="10" height="10" viewBox="0 0 1024 1024"><path fill="currentColor" d="M8.2 275.4c0-8.6 3.4-17.401 10-24.001c13.2-13.2 34.8-13.2 48 0l451.8 451.8l445.2-445.2c13.2-13.2 34.8-13.2 48 0s13.2 34.8 0 48L542 775.399c-13.2 13.2-34.8 13.2-48 0l-475.8-475.8c-6.8-6.8-10-15.4-10-24.199"/></svg>',
            chevronUp: '<svg xmlns="http://www.w3.org/2000/svg" width="10" height="10" viewBox="0 0 1024 1024"><path fill="currentColor" d="M8.2 751.4c0 8.6 3.4 17.401 10 24.001c13.2 13.2 34.8 13.2 48 0l451.8-451.8l445.2 445.2c13.2 13.2 34.8 13.2 48 0s13.2-34.8 0-48L542 251.401c-13.2-13.2-34.8-13.2-48 0l-475.8 475.8c-6.8 6.8-10 15.4-10 24.2z"/></svg>'
        }
    },
    created() {
        const store = useDateStore();
        this.companyId = this.storage.companyDetails.id;
        // this.dashboardLink = 'dashboard/'+this.companyId;
        this.companyName = this.storage.companyDetails.orgname;
        this.getNotificationList(this.currentPage);
        //console.log("testest");
        this.dateStore = store;
    },
    mounted() {
        const storedRole = localStorage.getItem("role");
        // console.log("Stored role:", storedRole);
        try {
            this.role = storedRole;
            // console.log("Parsed role:", this.role);
            // console.log("Permissions:", this.role.permissions);
        } catch (error) {
            console.error("Invalid role JSON", error);
        }

    },
    computed: {
          isDashboard() {
                return this.$route.name === 'AdminDashboard'; // or use this.$route.path
            },
        formattedDate() {
            const dateObject = new Date();
            return moment(dateObject).format('LLLL');
        },
        displayDay() {
            const selected = this.dateStore.selectedDate
                ? moment(this.dateStore.selectedDate)
                : moment();
            return selected.format('D'); // e.g., 17
        },
        displayLabel() {
            const selected = this.dateStore.selectedDate
                ? moment(this.dateStore.selectedDate)
                : moment();
            const today = moment();

            if (selected.isSame(today, 'day')) {
                return 'Today';
            }
            return selected.format('ddd'); // e.g., Monday
        }
    },
    methods: {
        onDateChange(newDate) {
            this.date = newDate;
            this.dateStore.setDate(this.date); // ✅ using store safely here
        },
        getNotificationList(page) {
            if (this.noMoreNotifications || this.busy) return;

            this.busy = true;

            axios
                .get(`${BASE_URL}/notifications/view?page=${page}&limit=6&company_id=${this.companyId}`)
                .then((res) => {
                    if (res.data.notifications.length === 0) {
                        this.noMoreNotifications = true;
                    } else {
                        this.totalNotificationCount = res.data.count;
                        this.notificationList.notifications.push(...res.data.notifications);
                        this.currentPage++;
                    }
                })
                .catch((err) => {
                    console.error(err);
                })
                .finally(() => {
                    this.busy = false;
                });
        },
        handleScroll(event) {
            const el = event.target;
            if (el.scrollTop + el.clientHeight >= el.scrollHeight - 10) {
                this.getNotificationList(this.currentPage);
            }
        },
        markAsRead(module, pageId, notificationId) {
            axios
                .post(`${BASE_URL}/notifications/read`, { notificationId: notificationId })
                .then(() => {
                    this.$router.push('/' + module);
                    // Decrease count
                    if (this.totalNotificationCount > 0) {
                        this.totalNotificationCount--;
                    }

                    const notification = this.notificationList.notifications.find(
                        (n) => n.id === notificationId
                    );
                    if (notification) {
                        notification.read = true;
                    }


                })
                .catch((err) => {
                    console.error('Error marking as read:', err);
                });
        },
        formatTime(time) {
            if (!time) return '';
            return moment(time, ['h:mm A', 'HH:mm']).format('h:mm A');
        },
        formatDate(date) {
            if (!date) return '';
            return moment(date).format('MM-DD-YYYY');
        },

        HandelFirstDropdown(val) {
            if (val === this.firstSideBarDrop) {
                this.firstSideBarDrop = '';
            } else {
                this.firstSideBarDrop = val;
            }
            this.isSidebar = true;
        },

        HandelSecondDropdown(val) {
            if (val === this.secondSideBarDrop) {
                this.secondSideBarDrop = '';
            } else {
                this.secondSideBarDrop = val;
            }
            this.isSidebar = true;
        },
        toggleAccordion(index) {
            this.openIndex = this.openIndex === index ? null : index;
        },
        toggleDropdown(type) {
            this.activeDropdown = this.activeDropdown === type ? null : type;
        },
        closeDropdown() {
            this.activeDropdown = null;
        },
        handleDatepickerClick() {
            // This forces the datepicker to close and reopen
            this.$refs.datepickerRef.$el.querySelector('input').blur();
            //setTimeout(() => {
            this.$refs.datepickerRef.$el.querySelector('input').focus();
            //}, 0);
        },
    }

};
</script>